/** @jsx jsx */

import { css, jsx } from '@emotion/core';

const SelectOptions = ({ children, ...props }) => {
  return (
    <div
      id={`select-options-${props?.id || ''}`}
      css={css`
        //
      `}
    >
      {children}
    </div>
  );
};

export default SelectOptions;
